/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mediaQueries } from '@everlywell/leaves';
import styled, { css } from 'styled-components';

export const InnerSection = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 350px;

  ${mediaQueries.forTabletVerticalUp} {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    height: 453px;
  }
`;

export const InnerContent = styled.div`
  position: relative;
`;

interface SectionProps {
  backgroundColor?: string;
  verticalCenter?: boolean;
}
export const Section = styled.section<SectionProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  ${({ verticalCenter }) =>
    verticalCenter &&
    css`
      ${InnerSection} {
        width: 100%;

        ${mediaQueries.forTabletVerticalUp} {
          justify-content: center;
        }
      }
    `}
`;
